var _toConsumableArray = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var Promise = require('bluebird'),
    _require = require('./transaction'),
    Transaction = _require.Transaction,
    _require2 = require('./constant'),
    NULL_HASH = _require2.NULL_HASH,
    _require3 = require('./entry'),
    Entry = _require3.Entry,
    _require4 = require('./blocks'),
    DirectoryBlock = _require4.DirectoryBlock,
    AdminBlock = _require4.AdminBlock,
    EntryBlock = _require4.EntryBlock,
    FactoidBlock = _require4.FactoidBlock,
    EntryCreditBlock = _require4.EntryCreditBlock,
    _require5 = require('./addresses'),
    getPublicAddress = _require5.getPublicAddress,
    _require6 = require('./util'),
    toHex = _require6.toHex;

function getChainHead(factomd, chainId) {
  return factomd.call('chain-head', {
    chainid: toHex(chainId)
  }).then(function (ch) {
    return {
      keyMR: ch.chainhead,
      chainInProcessList: ch.chaininprocesslist
    };
  });
}

function getEntry(_x, _x2, _x3) {
  return _getEntry.apply(this, arguments);
}

function _getEntry() {
  _getEntry = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(factomd, entryHash, entryBlockContext) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", factomd.call('entry', {
              hash: toHex(entryHash)
            }).then(function (e) {
              return toEntry(e, entryBlockContext);
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getEntry.apply(this, arguments);
}

function getEntryWithBlockContext(_x4, _x5) {
  return _getEntryWithBlockContext.apply(this, arguments);
}

function _getEntryWithBlockContext() {
  _getEntryWithBlockContext = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(factomd, entryHash) {
    var entryBlockKeyMR, entryBlock, timestamp;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return factomd.call('receipt', {
              hash: toHex(entryHash)
            }).then(function (r) {
              return r.receipt.entryblockkeymr;
            });

          case 2:
            entryBlockKeyMR = _context2.sent;
            _context2.next = 5;
            return factomd.call('entry-block', {
              keymr: entryBlockKeyMR
            });

          case 5:
            entryBlock = _context2.sent;
            timestamp = entryBlock.entrylist.find(function (e) {
              return e.entryhash === entryHash;
            }).timestamp;
            return _context2.abrupt("return", getEntry(factomd, entryHash, buildEntryBlockContext(entryBlockKeyMR, entryBlock, timestamp)));

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getEntryWithBlockContext.apply(this, arguments);
}

function getFirstEntry(_x6, _x7) {
  return _getFirstEntry.apply(this, arguments);
}

function _getFirstEntry() {
  _getFirstEntry = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(factomd, chainId) {
    var chainHead, keyMR, entryBlock, latestNonNullKeyMR, firstEntry;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getChainHead(factomd, chainId);

          case 2:
            chainHead = _context3.sent;

            if (!(chainHead.keyMR === '' && chainHead.chainInProcessList)) {
              _context3.next = 5;
              break;
            }

            throw new Error('Chain not yet included in a Directory Block');

          case 5:
            keyMR = chainHead.keyMR;

          case 6:
            if (!(keyMR !== NULL_HASH)) {
              _context3.next = 14;
              break;
            }

            latestNonNullKeyMR = keyMR;
            _context3.next = 10;
            return factomd.call('entry-block', {
              keymr: keyMR
            });

          case 10:
            entryBlock = _context3.sent;
            keyMR = entryBlock.header.prevkeymr;
            _context3.next = 6;
            break;

          case 14:
            firstEntry = entryBlock.entrylist[0];
            return _context3.abrupt("return", getEntry(factomd, firstEntry.entryhash, buildEntryBlockContext(latestNonNullKeyMR, entryBlock, firstEntry.timestamp)));

          case 16:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getFirstEntry.apply(this, arguments);
}

function getAllEntriesOfChain(_x8, _x9) {
  return _getAllEntriesOfChain.apply(this, arguments);
}

function _getAllEntriesOfChain() {
  _getAllEntriesOfChain = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(factomd, chainId) {
    var allEntries, chainHead, keyMR, _ref, entries, previousKeyMR;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            allEntries = [];
            _context4.next = 3;
            return getChainHead(factomd, chainId);

          case 3:
            chainHead = _context4.sent;

            if (!(chainHead.keyMR === '' && chainHead.chainInProcessList)) {
              _context4.next = 6;
              break;
            }

            throw new Error('Chain not yet included in a Directory Block');

          case 6:
            keyMR = chainHead.keyMR;

          case 7:
            if (!(keyMR !== NULL_HASH)) {
              _context4.next = 17;
              break;
            }

            _context4.next = 10;
            return getAllEntriesOfEntryBlock(factomd, keyMR);

          case 10:
            _ref = _context4.sent;
            entries = _ref.entries;
            previousKeyMR = _ref.previousKeyMR;
            allEntries.push.apply(allEntries, _toConsumableArray(entries.reverse()));
            keyMR = previousKeyMR;
            _context4.next = 7;
            break;

          case 17:
            return _context4.abrupt("return", Promise.resolve(allEntries.reverse()));

          case 18:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getAllEntriesOfChain.apply(this, arguments);
}

function rewindChainWhile(_x10, _x11, _x12, _x13) {
  return _rewindChainWhile.apply(this, arguments);
}

function _rewindChainWhile() {
  _rewindChainWhile = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5(factomd, chainId, predicate, func) {
    var chainHead, keyMR, _ref2, entries, previousKeyMR, i;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(typeof predicate !== 'function')) {
              _context5.next = 2;
              break;
            }

            throw new Error("".concat(predicate, " is not a function"));

          case 2:
            if (!(typeof func !== 'function')) {
              _context5.next = 4;
              break;
            }

            throw new Error("".concat(func, " is not a function"));

          case 4:
            _context5.next = 6;
            return getChainHead(factomd, chainId);

          case 6:
            chainHead = _context5.sent;

            if (!(chainHead.keyMR === '' && chainHead.chainInProcessList)) {
              _context5.next = 9;
              break;
            }

            throw new Error('Chain not yet included in a Directory Block');

          case 9:
            keyMR = chainHead.keyMR;

          case 10:
            if (!(keyMR !== NULL_HASH)) {
              _context5.next = 33;
              break;
            }

            _context5.next = 13;
            return getAllEntriesOfEntryBlock(factomd, keyMR);

          case 13:
            _ref2 = _context5.sent;
            entries = _ref2.entries;
            previousKeyMR = _ref2.previousKeyMR;
            i = entries.length - 1;

          case 17:
            _context5.t0 = i >= 0;

            if (!_context5.t0) {
              _context5.next = 22;
              break;
            }

            _context5.next = 21;
            return predicate(entries[i]);

          case 21:
            _context5.t0 = _context5.sent;

          case 22:
            if (!_context5.t0) {
              _context5.next = 28;
              break;
            }

            _context5.next = 25;
            return func(entries[i]);

          case 25:
            i--;
            _context5.next = 17;
            break;

          case 28:
            if (!(i >= 0)) {
              _context5.next = 30;
              break;
            }

            return _context5.abrupt("break", 33);

          case 30:
            keyMR = previousKeyMR;
            _context5.next = 10;
            break;

          case 33:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _rewindChainWhile.apply(this, arguments);
}

function getAllEntriesOfEntryBlock(_x14, _x15) {
  return _getAllEntriesOfEntryBlock.apply(this, arguments);
}

function _getAllEntriesOfEntryBlock() {
  _getAllEntriesOfEntryBlock = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee6(factomd, keyMR) {
    var entryBlock, entries;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return factomd.call('entry-block', {
              keymr: keyMR
            });

          case 2:
            entryBlock = _context6.sent;
            _context6.next = 5;
            return Promise.map(entryBlock.entrylist, function (e) {
              return getEntry(factomd, e.entryhash, buildEntryBlockContext(keyMR, entryBlock, e.timestamp));
            });

          case 5:
            entries = _context6.sent;
            return _context6.abrupt("return", {
              entries: entries,
              previousKeyMR: entryBlock.header.prevkeymr
            });

          case 7:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getAllEntriesOfEntryBlock.apply(this, arguments);
}

function buildEntryBlockContext(entryBlockKeyMR, entryBlock, entryTimestamp) {
  return {
    entryTimestamp: entryTimestamp,
    directoryBlockHeight: entryBlock.header.dbheight,
    entryBlockTimestamp: entryBlock.header.timestamp,
    entryBlockSequenceNumber: entryBlock.header.blocksequencenumber,
    entryBlockKeyMR: entryBlockKeyMR
  };
}

function toEntry(entry, entryBlockContext) {
  return Entry.builder().chainId(entry.chainid, 'hex').extIds(entry.extids, 'hex').content(entry.content, 'hex').blockContext(entryBlockContext).timestamp(entryBlockContext ? entryBlockContext.entryTimestamp * 1000 : undefined).build();
}

function getBalance(factomd, address) {
  var publicAddress = getPublicAddress(address);
  var balance = publicAddress[0] === 'E' ? factomd.call.bind(factomd, 'entry-credit-balance') : factomd.call.bind(factomd, 'factoid-balance');
  return balance({
    address: publicAddress
  }).then(function (res) {
    return res.balance;
  });
}

function chainExists(factomd, chainId) {
  return factomd.call('chain-head', {
    chainid: toHex(chainId)
  }).then(function () {
    return true;
  }).catch(function (err) {
    if (err.code === -32009) {
      return false;
    }

    throw err;
  });
}

function getTransaction(_x16, _x17) {
  return _getTransaction.apply(this, arguments);
}

function _getTransaction() {
  _getTransaction = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee7(factomd, txId) {
    var tx;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (!(typeof txId !== 'string')) {
              _context7.next = 2;
              break;
            }

            throw new Error("Argument is not a transaction ID: ".concat(txId));

          case 2:
            _context7.next = 4;
            return factomd.call('transaction', {
              hash: txId
            });

          case 4:
            tx = _context7.sent;

            if (!tx.factoidtransaction) {
              _context7.next = 9;
              break;
            }

            return _context7.abrupt("return", new Transaction(tx.factoidtransaction, {
              factoidBlockKeyMR: tx.includedintransactionblock,
              directoryBlockKeyMR: tx.includedindirectoryblock,
              directoryBlockHeight: tx.includedindirectoryblockheight
            }));

          case 9:
            throw new Error("No Transaction with ID [".concat(txId, "] found."));

          case 10:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _getTransaction.apply(this, arguments);
}

function getEntryCreditRate(factomd) {
  return factomd.call('entry-credit-rate').then(function (r) {
    return r.rate;
  });
}

function getHeights(_x18) {
  return _getHeights.apply(this, arguments);
}

function _getHeights() {
  _getHeights = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee8(factomd) {
    var heights;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return factomd.call('heights');

          case 2:
            heights = _context8.sent;
            return _context8.abrupt("return", {
              directoryBlockHeight: heights.directoryblockheight,
              leaderHeight: heights.leaderheight,
              entryBlockHeight: heights.entryblockheight,
              entryHeight: heights.entryheight
            });

          case 4:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _getHeights.apply(this, arguments);
}

function getDirectoryBlockHead(factomd) {
  return factomd.call('directory-block-head').then(function (r) {
    return getDirectoryBlock(factomd, r.keymr);
  });
}

function getDirectoryBlock(factomd, arg) {
  var dbPromise;

  switch (typeof arg) {
    case 'number':
      if (arg < 0) {
        throw new RangeError('Directory Block height out of range');
      }

      dbPromise = factomd.call('dblock-by-height', {
        height: arg
      });
      break;

    case 'string':
      dbPromise = factomd.call('directory-block', {
        keymr: arg
      });
      break;

    default:
      throw Error("Invalid argument: ".concat(arg));
  }

  return dbPromise.then(function (r) {
    return new DirectoryBlock(r, arg);
  });
}

function getEntryBlock(factomd, keyMR) {
  if (typeof keyMR !== 'string') {
    throw new Error('Argument should be the KeyMR of the Entry Block');
  }

  return factomd.call('entry-block', {
    keymr: keyMR
  }).then(function (r) {
    return new EntryBlock(r, keyMR);
  });
}

function getFactoidBlock(factomd, arg) {
  var fbPromise;

  switch (typeof arg) {
    case 'number':
      if (arg < 0) {
        throw new RangeError('Factoid Block height out of range');
      }

      fbPromise = factomd.call('fblock-by-height', {
        height: arg
      });
      break;

    case 'string':
      fbPromise = factomd.call('factoid-block', {
        keymr: arg
      });
      break;

    default:
      throw Error("Invalid argument: ".concat(arg));
  }

  return fbPromise.then(function (r) {
    return new FactoidBlock(r);
  });
}

function getEntryCreditBlock(factomd, arg) {
  var ecbPromise;

  switch (typeof arg) {
    case 'number':
      if (arg < 0) {
        throw new RangeError('Entry Credit Block height out of range');
      }

      ecbPromise = factomd.call('ecblock-by-height', {
        height: arg
      });
      break;

    case 'string':
      ecbPromise = factomd.call('entrycredit-block', {
        keymr: arg
      });
      break;

    default:
      throw Error("Invalid argument: ".concat(arg));
  }

  return ecbPromise.then(function (r) {
    return new EntryCreditBlock(r);
  });
}

function getAdminBlock(factomd, arg) {
  var abPromise;

  switch (typeof arg) {
    case 'number':
      if (arg < 0) {
        throw new RangeError('Admin Block height out of range');
      }

      abPromise = factomd.call('ablock-by-height', {
        height: arg
      });
      break;

    case 'string':
      abPromise = factomd.call('admin-block', {
        keymr: arg
      });
      break;

    default:
      throw Error("Invalid argument: ".concat(arg));
  }

  return abPromise.then(function (r) {
    return new AdminBlock(r);
  });
}

module.exports = {
  getEntry: getEntry,
  getEntryWithBlockContext: getEntryWithBlockContext,
  getAllEntriesOfChain: getAllEntriesOfChain,
  getFirstEntry: getFirstEntry,
  getChainHead: getChainHead,
  chainExists: chainExists,
  getEntryCreditRate: getEntryCreditRate,
  getTransaction: getTransaction,
  getBalance: getBalance,
  getHeights: getHeights,
  getDirectoryBlockHead: getDirectoryBlockHead,
  getDirectoryBlock: getDirectoryBlock,
  getEntryBlock: getEntryBlock,
  getAdminBlock: getAdminBlock,
  getFactoidBlock: getFactoidBlock,
  getEntryCreditBlock: getEntryCreditBlock,
  rewindChainWhile: rewindChainWhile
};